import { useLocation, Link } from 'react-router-dom'
import React from 'react'
import { useState } from 'react'
import { FiMenu } from 'react-icons/fi'
import { twMerge } from 'tailwind-merge'

import Logo from '../Logo'
import Cart from '../../../components/Cart'

const linksByRoute = {
	'/': [
		// { label: 'Benefícios', href: '#vantagens' },
		// { label: 'Módulos', href: '#modulos' },
		// { label: 'Depoimentos', href: '#depoimentos' },
		// { label: 'Contato', href: '#contatos' }
	],
	'/produtos/prontuario': [
		// { label: 'Benefícios', href: '#beneficios' },
		// { label: 'Como funciona?', href: '#funcionamento' },
		// { label: 'Planos', href: '#planos' },
		// { label: 'Contato', href: '/contatos' }
	],
	'/login': [],
	'/signup': []
}

const buttonsByRoute = {
	'/': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/produtos/prontuario': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '#planos', label: 'Assinar', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/login': [
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/signup': [
		{ to: '/login', label: 'Área do usuário', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/contatos': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/quem-somos': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/politica-privacidade': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	],
	'/termos-de-uso': [
		{ to: '/login', label: 'Área do usuário', classes: 'text-slate-800' },
		{ to: '/signup', label: 'Cadastre-se', classes: 'bg-emerald-600 text-white hover:text-white hover:bg-emerald-700' }
	]
}

export default function () {
	const location = useLocation()

	const [showDropdownMenu, setShowDropdownMenu] = useState(false)

	const links = linksByRoute[location.pathname] || []
	const buttons = buttonsByRoute[location.pathname] || []

	return (
		<header className="border-b border-gray-100 bg-white backdrop-blur-sm sticky top-0" style={{
			zIndex: 1,
			boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)'
		}}>
			<div className="container mx-auto px-4 py-4 flex justify-between items-center">
				<Logo />

				<nav className="hidden lg:flex items-center space-x-6">
					{links.map(link => (
						<a key={link.href} href={link.href} className="text-gray-700 hover:text-primary transition-colors font-semibold">
							{link.label}
						</a>
					))}
				</nav>

				<div className="flex items-center">
					<div 
						className={twMerge('p-2 rounded-full cursor-pointer hover:opacity-60 hidden', (!!links.length || !!buttons.length) ? 'block lg:hidden' : '')} 
						onClick={() => { setShowDropdownMenu(old => !old) }}
					>
						<FiMenu size={28} className="text-slate-800" />
					</div>

					<div className="flex justify-end mx-2 lg:hidden">
						<Cart
							dropdownClassNames="top-24"
						/>
					</div>
				</div>
				
				{showDropdownMenu && (
					<nav 
						className="fixed lg:hidden top-[89px] bg-white w-full left-0 animated fadeIn faster" 
						style={{ boxShadow: '0 4px 5px 0 rgba(0,0,0,0.14),0 1px 10px 0 rgba(0,0,0,0.12),0 2px 4px -1px rgba(0,0,0,0.3)' }}
					>
						<ul>
							{links.map(link => (
								<li className="w-full flex flex-col" key={link.href}>
									<a href={link.href} className="text-gray-700 transition-colors font-semibold w-full py-4 border-b border-b-slate-200 text-center">
										{link.label}
									</a>
								</li>
							))}
						</ul>

						<ul className="flex gap-3 m-3 justify-center">
							{buttons.map(button => {
								const eAncora = button.to.startsWith('#')

								return eAncora ? (
									<li key={button.to}>
										<a href={button.to} className={`flex px-4 py-2 rounded-md font-semibold border border-gray-300 text-center ${button.classes}`}>
											{button.label}
										</a>
									</li>
								) : (
									<li key={button.to}>
										<Link to={button.to} className={`flex px-4 py-2 rounded-md font-semibold border border-gray-300 text-center ${button.classes}`}>
											{button.label}
										</Link>
									</li>
								)
							})}
						</ul>
					</nav>
				)}
				
				<div className="hidden lg:flex items-center space-x-4">
					{buttons.map(button => (
						<a href={button.to} key={button.to} className={`hidden md:inline-flex px-4 py-2 rounded-md font-semibold border border-gray-300 ${button.classes}`}>
							{button.label}
						</a>
					))}

					<Cart 
						dropdownClassNames="md:top-24"
					/>
				</div>
			</div>
		</header>
	)
}
